function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'military-green': 'rgb(94, 107, 86)','heather-brown': 'rgb(88, 64, 50)','heather-true-royal': 'rgb(63, 112, 185)','heather-slate': 'rgb(70, 97, 103)','graphite-heather': 'rgb(109, 111, 114)','sport-grey': 'rgb(180, 180, 180)','athletic-heather': 'rgb(199, 199, 199)','royal': 'rgb(48, 77, 147)','true-royal': 'rgb(7, 65, 185)','red': 'rgb(176, 39, 44)','heather-olive': 'rgb(102, 102, 77)','dark-heather': 'rgb(91, 96, 103)','sage': 'rgb(134, 154, 131)','vintage-brown': 'rgb(128, 105, 90)','apple': 'rgb(122, 176, 91)','hot-pink': 'rgb(225, 94, 126)','cobalt': 'rgb(51, 116, 194)','deep-heather': 'rgb(134, 138, 135)','cardinal': 'rgb(142, 25, 50)',};

    this.images = {'grey-red-triblend': 'url("//shirtguysondemand.com/cdn/shop/files/GREYRED_68x.png?v=6955373292351663367")','deep-heather-black': 'url("//shirtguysondemand.com/cdn/shop/files/DHB_68x.png?v=9971737582732832819")','greyblack': 'url("//shirtguysondemand.com/cdn/shop/files/GreyBlack_68x.png?v=839870788626248874")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
